import request from '@/utils/request'

function unwrapData(res) {
  if (res && res.code && res.code !== 2000) {
    return Promise.reject(new Error(res.message || '请求失败'))
  }
  return (res && res.items) != null ? res.items : res
}

export function fetchHistoryPeriods(params = {}) {
  return request({
    url: '/pc/home/history/periods',
    method: 'get',
    params
  }).then(unwrapData)
}

export function fetchEntityCount() {
  return request({
    url: '/pc/home/entity/count',
    method: 'get'
  }).then(unwrapData)
}

function extractStartYear(range) {
  const text = String(range || '').trim()
  if (!text) return ''
  const match = text.match(/-?\d{1,4}/)
  return match ? match[0] : text
}

export function mapHistoryPeriod(item) {
  if (!item) return null
  const yearRange = item.yearRange || item.range || ''
  return {
    id: item.id != null ? String(item.id) : '',
    yearRange,
    startYear: item.startYear || extractStartYear(yearRange),
    title: item.title || item.name || '',
    theme: item.theme || 'cream',
    description: item.description || item.info || '',
    image: item.image || '',
    events: Array.isArray(item.events)
      ? item.events.map((event) => ({
          id: event.id,
          title: event.name || event.title || '',
          description: event.eventDescription || event.description || '',
          image: event.image || ''
        }))
      : []
  }
}
